import {Model} from "@vuex-orm/core";

export default class Liability extends Model {
    /* Follow the namespace in the backend */
    static entity = 'Household\\Model\\Liability';


    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            household_id: this.number(0),
            type_cd: this.attr(''),
            amount_owed: this.number(0),
            account_number: this.number(null),
            monthly_payment: this.number(0),
        }
    }

    get accountsOverviewName() {
        let name = '';

        if (this.name) {
            name = this.name;
        }

        if (this.account_number) {
            name = name + ' - ' + this.account_number;
        }

        return name === '' ? '--' :  name;
    }

    get accountsOverviewValue() {
        return this.amount_owed;
    }
}
